/**
 * 기능 공개 여부.
 *
 * 서버 API가 준비돼 있어도 아직 사용자에게 열지 않은 기능이 있다.
 * 화면을 지우는 대신 여기서 끄면 진입점은 '준비 중'으로 남고
 * 본문은 Coming Soon으로 대체된다. 켤 때는 이 값만 true로 바꾸면 된다.
 */

/** 메시지 — 런칭 전 */
export const MESSAGING_ENABLED = false;
